export const CLEAR_MESSAGE = "CLEAR_MESSAGE";
export const USER_CLEAR_MESSAGE = "USER_CLEAR_MESSAGE";

export const LANGUAGE = "LANGUAGE";

export const DARK_THEME = "DARK_THEME";
export const OPEN_SIDEBAR = "OPEN_SIDEBAR";
export const DRAW_SIDEBAR = "DRAW_SIDEBAR";
export const DRAW_SIDEBAR_OPEN = "DRAW_SIDEBAR_OPEN";
export const DRAW_SIDEBAR_CLOSE = "DRAW_SIDEBAR_CLOSE";

export const FETCH_COURSE_INDEX_START = "FETCH_COURSE_INDEX_START";
export const FETCH_COURSE_INDEX_SUCCESS = "FETCH_COURSE_INDEX_SUCCESS";
export const FETCH_COURSE_INDEX_FAIL = "FETCH_COURSE_INDEX_FAIL";

export const FETCH_COURSES_START = "FETCH_COURSES_START";
export const FETCH_COURSES_SUCCESS = "FETCH_COURSES_SUCCESS";
export const FETCH_COURSES_FAIL = "FETCH_COURSES_FAIL";

export const FETCH_COURSE_DETAIL_START = "FETCH_COURSE_DETAIL_START";
export const FETCH_COURSE_DETAIL_SUCCESS = "FETCH_COURSE_DETAIL_SUCCESS";
export const FETCH_COURSE_DETAIL_FAIL = "FETCH_COURSE_DETAIL_FAIL";

export const FETCH_USER_DETAIL_START = "FETCH_USER_DETAIL_START";
export const FETCH_USER_DETAIL_SUCCESS = "FETCH_USER_DETAIL_SUCCESS";
export const FETCH_USER_DETAIL_FAIL = "FETCH_USER_DETAIL_FAIL";

export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_LOGOUT = "AUTH_LOGOUT";

export const SET_AUTH_REDIRECT_PATH = "SET_AUTH_REDIRECT_PATH";

export const ENROLL_COURSE_START = "ENROLL_COURSE_START";
export const ENROLL_COURSE_SUCCESS = "ENROLL_COURSE_SUCCESS";
export const ENROLL_COURSE_FAIL = "ENROLL_COURSE_FAIL";

export const FETCH_USER_LIST_IN_THIS_COURSE_START =
  "FETCH_USER_LIST_IN_THIS_COURSE_START";
export const FETCH_USER_LIST_IN_THIS_COURSE_SUCCESS =
  "FETCH_USER_LIST_IN_THIS_COURSE_SUCCESS";
export const FETCH_USER_LIST_IN_THIS_COURSE_FAIL =
  "FETCH_USER_LIST_IN_THIS_COURSE_FAIL";

export const FETCH_USERS_START = "FETCH_USERS_START";
export const FETCH_USERS_SUCCESS = "FETCH_USERS_SUCCESS";
export const FETCH_USERS_FAIL = "FETCH_USERS_FAIL";

export const FETCH_COURSE_APPROVAL_PENDING_START =
  "FETCH_COURSE_APPROVAL_PENDING_START";
export const FETCH_COURSE_APPROVAL_PENDING_SUCCESS =
  "FETCH_COURSE_APPROVAL_PENDING_SUCCESS";
export const FETCH_COURSE_APPROVAL_PENDING_FAIL =
  "FETCH_COURSE_APPROVAL_PENDING_FAIL";

export const DELETE_USER_START = "DELETE_USER_START";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_FAIL = "DELETE_USER_FAIL";

export const ADD_USER_START = "ADD_USER_START";
export const ADD_USER_SUCCESS = "ADD_USER_SUCCESS";
export const ADD_USER_FAIL = "ADD_USER_FAIL";

export const APPROVE_COURSE_PENDING_START = "APPROVE_COURSE_PENDING_START";
export const APPROVE_COURSE_PENDING_SUCCESS = "APPROVE_COURSE_PENDING_SUCCESS";
export const APPROVE_COURSE_PENDING_FAIL = "APPROVE_COURSE_PENDING_FAIL";

export const FETCH_COURSE_APPROVED_START = "FETCH_COURSE_APPROVED_START";
export const FETCH_COURSE_APPROVED_SUCCESS = "FETCH_COURSE_APPROVED_SUCCESS";
export const FETCH_COURSE_APPROVED_FAIL = "FETCH_COURSE_APPROVED_FAIL";

export const DISAPPROVE_COURSE_START = "DISAPPROVE_COURSE_START";
export const DISAPPROVE_COURSE_SUCCESS = "DISAPPROVE_COURSE_SUCCESS";
export const DISAPPROVE_COURSE_FAIL = "DISAPPROVE_COURSE_FAIL";

export const FETCH_COURSE_NONE_ENROLL_START = "FETCH_COURSE_NONE_ENROLL_START";
export const FETCH_COURSE_NONE_ENROLL_SUCCESS =
  "FETCH_COURSE_NONE_ENROLL_SUCCESS";
export const FETCH_COURSE_NONE_ENROLL_FAIL = "FETCH_COURSE_NONE_ENROLL_FAIL";

export const FETCH_INFO_CLICK = "FETCH_INFO_CLICK";
export const EDIT_USER_CLICK = "EDIT_USER_CLICK";
export const ADD_USER_CLICK = "ADD_USER_CLICK";

export const CHOOSE_GROUP = "CHOOSE_GROUP";
export const CHOOSE_COURSE_TYPE = "CHOOSE_COURSE_TYPE";

export const SEARCH_USER_START = "SEARCH_USER_START";
export const SEARCH_USER_SUCCESS = "SEARCH_USER_SUCCESS";
export const SEARCH_USER_FAIL = "SEARCH_USER_FAIL";

export const FETCH_COURSES_LIST_START = "FETCH_COURSES_LIST_START";
export const FETCH_COURSES_LIST_SUCCESS = "FETCH_COURSES_LIST_SUCCESS";
export const FETCH_COURSES_LIST_FAIL = "FETCH_COURSES_LIST_FAIL";

export const FETCH_USERS_CLICK = "FETCH_USERS_CLICK";
export const EDIT_COURSE_CLICK = "EDIT_COURSE_CLICK";
export const ADD_COURSE_CLICK = "ADD_COURSE_CLICK";

export const ADD_COURSE_START = "ADD_COURSE_START";
export const ADD_COURSE_SUCCESS = "ADD_COURSE_SUCCESS";
export const ADD_COURSE_FAIL = "ADD_COURSE_FAIL";

export const FETCH_USER_LIST_OF_COURSE_START =
  "FETCH_USER_LIST_OF_COURSE_START";
export const FETCH_USER_LIST_OF_COURSE_SUCCESS =
  "FETCH_USER_LIST_OF_COURSE_SUCCESS";
export const FETCH_USER_LIST_OF_COURSE_FAIL = "FETCH_USER_LIST_OF_COURSE_FAIL";

export const FETCH_USER_PENDING_LIST_OF_COURSE_START =
  "FETCH_USER_PENDING_LIST_OF_COURSE_START";
export const FETCH_USER_PENDING_LIST_OF_COURSE_SUCCESS =
  "FETCH_USER_PENDING_LIST_OF_COURSE_SUCCESS";
export const FETCH_USER_PENDING_LIST_OF_COURSE_FAIL =
  "FETCH_USER_PENDING_LIST_OF_COURSE_FAIL";

export const FETCH_USER_REFUSE_LIST_OF_COURSE_START =
  "FETCH_USER_REFUSE_LIST_OF_COURSE_START";
export const FETCH_USER_REFUSE_LIST_OF_COURSE_SUCCESS =
  "FETCH_USER_REFUSE_LIST_OF_COURSE_SUCCESS";
export const FETCH_USER_REFUSE_LIST_OF_COURSE_FAIL =
  "FETCH_USER_REFUSE_LIST_OF_COURSE_FAIL";

export const APPROVE_USER_PENDING_START = "APPROVE_USER_PENDING_START";
export const APPROVE_USER_PENDING_SUCCESS = "APPROVE_USER_PENDING_SUCCESS";
export const APPROVE_USER_PENDING_FAIL = "APPROVE_USER_PENDING_FAIL";

export const DISAPPROVE_USER_START = "DISAPPROVE_USER_START";
export const DISAPPROVE_USER_SUCCESS = "DISAPPROVE_USER_SUCCESS";
export const DISAPPROVE_USER_FAIL = "DISAPPROVE_USER_FAIL";

export const UPLOAD_IMAGE_START = "UPLOAD_IMAGE_START";
export const UPLOAD_IMAGE_SUCCESS = "UPLOAD_IMAGE_SUCCESS";
export const UPLOAD_IMAGE_FAIL = "UPLOAD_IMAGE_FAIL";

export const DELETE_COURSE_START = "DELETE_COURSE_START";
export const DELETE_COURSE_SUCCESS = "DELETE_COURSE_SUCCESS";
export const DELETE_COURSE_FAIL = "DELETE_COURSE_FAIL";


//My changes
export const FETCH_PRODUCTS = "FETCH_PRODUCTS";
export const SET_PRODUCTS = "SET_PRODUCTS";
export const SELECTED_PRODUCT = "SELECTED_PRODUCT";
export const REMOVE_SELECTED_PRODUCT = "REMOVE_SELECTED_PRODUCT";

export const FETCH_PRODUCT_CAT_START = "FETCH_PRODUCT_CAT_START";
export const FETCH_PRODUCT_CAT_SUCCESS = "FETCH_PRODUCT_CAT_SUCCESS";
export const FETCH_PRODUCT_CAT_FAIL = "FETCH_PRODUCT_CAT_FAIL";

export const ENROLL_PRODUCT_START = "ENROLL_PRODUCT_START";
export const ENROLL_PRODUCT_SUCCESS = "ENROLL_PRODUCT_SUCCESS";
export const ENROLL_PRODUCT_FAIL = "ENROLL_PRODUCT_FAIL";

export const FETCH_USER_LIST_IN_THIS_PRODUCT_START =
  "FETCH_USER_LIST_IN_THIS_PRODUCT_START";
export const FETCH_USER_LIST_IN_THIS_PRODUCT_SUCCESS =
  "FETCH_USER_LIST_IN_THIS_PRODUCT_SUCCESS";
export const FETCH_USER_LIST_IN_THIS_PRODUCT_FAIL =
  "FETCH_USER_LIST_IN_THIS_PRODUCT_FAIL";